module.exports = __webpack_public_path__ + "static/media/fruitTrucker.a3cf2587.jpg";